var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid" },
    _vm._l(_vm.positionBox, function (yItem, index) {
      return _c(
        "div",
        { key: index + "y", staticClass: "outer-class" },
        _vm._l(yItem, function (xItem, idx) {
          return _c(
            "div",
            {
              key: idx + "x",
              staticClass: "inner-class",
              style: _vm.classInfo,
            },
            [_vm._v("\n      " + _vm._s(xItem.el ? "." : "") + "\n    ")]
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }